var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 170,
    height: 170,
    rx: 85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 169,
    height: 169,
    rx: 84.5,
    stroke: "#DBEAFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.549 58.817c1.682 0 3.295.647 4.485 1.8a6.055 6.055 0 0 1 1.858 4.344c0 1.63-.669 3.193-1.858 4.346a6.448 6.448 0 0 1-4.485 1.8l35.338-.002c1.683 0 3.296.647 4.485 1.8a6.047 6.047 0 0 1 1.858 4.345c0 1.63-.668 3.192-1.857 4.345a6.45 6.45 0 0 1-4.485 1.8l-36.245.001a6.446 6.446 0 0 0-4.484 1.8 6.048 6.048 0 0 0-1.858 4.346c0 1.63.668 3.192 1.858 4.345a6.447 6.447 0 0 0 4.485 1.8l22.653-.002c1.682 0 3.295.648 4.485 1.8a6.05 6.05 0 0 1 1.858 4.345c0 1.63-.668 3.193-1.858 4.345a6.445 6.445 0 0 1-4.485 1.8l-36.244.002a6.45 6.45 0 0 1 4.485 1.799 6.05 6.05 0 0 1 1.858 4.345c0 1.63-.668 3.193-1.858 4.345a6.443 6.443 0 0 1-4.485 1.8l-88.798.004a6.445 6.445 0 0 1-4.485-1.8 6.048 6.048 0 0 1-1.858-4.345c0-1.629.668-3.192 1.857-4.345a6.45 6.45 0 0 1 4.485-1.8l36.245-.001a6.45 6.45 0 0 1-4.486-1.8 6.048 6.048 0 0 1-1.857-4.345c0-1.63.668-3.193 1.857-4.345a6.448 6.448 0 0 1 4.485-1.8H39.564a6.447 6.447 0 0 1-4.486-1.799 6.05 6.05 0 0 1-1.858-4.345 6.05 6.05 0 0 1 1.858-4.345 6.448 6.448 0 0 1 4.485-1.8h9.219c4.417 0 7.997-2.752 7.997-6.146 0-3.393-5.437-6.144-5.437-6.144a6.448 6.448 0 0 1-4.485-1.8 6.05 6.05 0 0 1-1.858-4.345c0-1.63.668-3.193 1.857-4.345a6.448 6.448 0 0 1 4.485-1.8l75.208-.003ZM29.596 89.545a6.009 6.009 0 0 1-1.069 3.414 6.304 6.304 0 0 1-2.846 2.264 6.533 6.533 0 0 1-3.665.35 6.41 6.41 0 0 1-3.247-1.682 6.088 6.088 0 0 1-1.736-3.146 5.966 5.966 0 0 1 .36-3.55 6.19 6.19 0 0 1 2.336-2.759 6.489 6.489 0 0 1 3.524-1.035c1.682 0 3.296.647 4.485 1.8a6.05 6.05 0 0 1 1.858 4.344Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.401 115.591h33.485a6.699 6.699 0 0 0 6.697-6.697V76.795c0-.888-.353-1.74-.981-2.367L96.473 56.299a3.349 3.349 0 0 0-2.367-.981H75.402a6.697 6.697 0 0 0-6.698 6.697v46.879a6.696 6.696 0 0 0 6.698 6.697Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.099 85.454h20.09m-20.09 13.394h20.09m6.697 16.743H75.402a6.697 6.697 0 0 1-6.698-6.697v-46.88a6.697 6.697 0 0 1 6.698-6.696h18.704c.888 0 1.74.353 2.368.981l18.128 18.129c.628.627.981 1.48.981 2.367v32.099a6.695 6.695 0 0 1-6.697 6.697Z",
    stroke: "#3B82F6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 176,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1143_13496"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1143_13496",
    result: "effect2_dropShadow_1143_13496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1143_13496",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocument);
export default __webpack_public_path__ + "static/media/noDocument.f5dc5d5e61b63c063a787464a1d2c7bd.svg";
export { ForwardRef as ReactComponent };